import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaMonto, validaSoloNumero, formatMoneda } from "../../util/varios";
import { Checkbox, Input, Textarea } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

const ModalTierra = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const txtDescrip = useRef();
  const txtValorPrivado = useRef();
  const btnCancela = useRef();
  const txtSector = useRef();
  const txtApendice = useRef();
  const txtValorMuni = useRef();
  const [labels, setLabels] = useState("Bs/m2");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idvalorterreno: "",
    apendice: "",
    sector: "",
    descripcion: "",
    valor: "",
    valorpriv: "",
    rural: 0,
  });
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState("0");
  const blanquear = () => {
    setValues({
      idvalorterreno: "",
      apendice: "",
      sector: "",
      descripcion: "",
      valor: "",
      valorpriv: "",
      rural: 0,
    });
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancela();
  };
  const cancelar = () => {
    props.onHideCancela();
    blanquear();
  };
  const onChange = (e) => {
    e.preventDefault();
    if (e.target.type === "text" || e.target.type === "textarea") {
      e.target.value = e.target.value;
      setValues({ ...values, [e.target.name]: e.target.value });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };
  const onChange2 = (e) => {
    if (e.target.name === "rural") {
      if (values.rural === 1) {
        setValues({ ...values, [e.target.name]: 0 });
        setLabels("Bs/m2");
      } else {
        setValues({ ...values, [e.target.name]: 1 });
        setLabels("Bs/HA");
      }
    }
  };

  const procesarDetalles = () => {
    let endpoint = `${op.conexion}/api/inmueble/actualizartierra`;
    let body;
    setActivate(true);
    body = {
      operacion: operacion,
      nid: operacion === 1 ? 0 : values.idvalorterreno,
      sect: txtSector.current.value,
      apen: txtApendice.current.value,
      descr: txtDescrip.current.value,
      valcon: txtValorMuni.current.value.replace(/\./g, "").replace(",", "."),
      valvac: txtValorPrivado.current.value
        .replace(/\./g, "")
        .replace(",", "."),
      rura: values.rural,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Registrado Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Modificado Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminado Exitosamente",
              icono: "exito",
            });
          }
          props.onHideRender();
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;
    if (txtSector.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Ingresar el sector",
        icono: "informacion",
      });
      sigue = false;
      txtSector.current.focus();
    } else if (txtApendice.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el apéndice",
        icono: "informacion",
      });
      sigue = false;
      txtApendice.current.focus();
    } else if (txtDescrip.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la descripción",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (txtValorPrivado.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la tarifa del Terreno Privado",
        icono: "informacion",
      });
      sigue = false;
      txtValorPrivado.current.focus();
    } else if (txtValorMuni.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la tarifa del Terreno Municipal",
        icono: "informacion",
      });
      sigue = false;
      txtValorMuni.current.focus();
    }
    if (sigue) {
      procesarDetalles();
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
    return formatMoneda(e);
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.tierra);
        }
      }}
    >
      <Modal.Header className="col-12 m-0 p-2 d-flex justify-content-between text-light azulGradiant rounded-top">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Valor de Terreno"
            : operacion === 2
            ? "Editar Valor de Terreno"
            : operacion === 3
            ? "Eliminar Valor de Terreno"
            : "Consultar Valor de Terreno"}
        </h3>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
          <div className="col-3 m-0 mb-2 p-0">
            <Input label = 'Código'
              disabled
              name="idvalorterreno"
              value={
                values.idvalorterreno != "" ? values.idvalorterreno.trim() : ""
              }
              onChange={onChange}
            />
          </div>
          <div className="col-4 m-0 mb-2 ml-auto p-0">
            <Input label = 'Sector Catastral:'
              ref={txtSector}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              name="sector"
              value={values.sector != "" ? values.sector : ""}
              maxLength={3}
              onChange={onChange}
            />
          </div>
          <div className="col-4 m-0 mb-2 p-0 pl-2">
            <Input label = 'Apéndice:'
              ref={txtApendice}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              name="apendice"
              value={values.apendice != "" ? values.apendice : ""}
              onChange={onChange}
              maxLength={2}
              onKeyUp={handleInputNumChange}
              onBlur={handleInputNumChange}
            />
          </div>
          <div className="col-3 m-0 mb-2 p-0">
            <Checkbox label = 'Zona Rural'
              disabled={operacion === 1 || operacion === 2 ? false : true}
              id="zonaRurarl"
              name="rural"
              checked={values.rural === 1 ? true : false}
              onChange={onChange2}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Textarea label = 'Descripción'
              style={{ height: 70 }}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              ref={txtDescrip}
              name="descripcion"
              value={values.descripcion != "" ? values.descripcion : ""}
              onChange={onChange}
            />
          </div>
          <div className="col-6 m-0 p-0 d-flex">
            <Input label = 'Valor Terreno Privado:'
              ref={txtValorPrivado}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="valorpriv"
              defaultValue={
                values.valorpriv
                  ? values.valorpriv != ""
                    ? formatMoneda(
                        values.valorpriv.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : ""
                  : ""
              }
              onChange={onChange}
            />
            <span className="input-group-text" id="inputGroup-sizing-sm">
              {labels}
            </span>
          </div>
          <div className="col-6 m-0 p-0 d-flex pl-2">
            <Input label = 'Valor Terreno Municipal:'
              ref={txtValorMuni}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="valor"
              defaultValue={
                values.valor
                  ? values.valor != ""
                    ? formatMoneda(
                        values.valor.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : ""
                  : ""
              }
              onChange={onChange}
            />
            <span className="input-group-text" id="inputGroup-sizing-sm">
              {labels}
            </span>
          </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};

export default ModalTierra;
